module.exports = __webpack_public_path__ + "img/1.949737b5.png";